type PartialStatus = { id: string; name: string; statusCategory: { key: string } };

export const getStatusGroupIdentityKey = (status: PartialStatus): string =>
	`STATUS_NAME__${status.name}___CATEGORY_KEY__${status.statusCategory.key}`;
